module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    ref: "dialog",
    attrs: {
      "title": "导入数据"
    }
  }, [_c('div', {
    staticClass: "form-tips fz-14 m-b-10"
  }, [(!this.onlyName) ? _c('span', [_vm._v("输入格式为“选项值|选项名称”，每行一条。(选项值为数字类型)")]) : _vm._e(), _vm._v(" "), (this.onlyName) ? _c('span', [_vm._v("输入格式为“选项名称”，每行一条。")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("(输入内容为空时，点击保存会清空该控件配置数据。)")])]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    attrs: {
      "type": "textarea",
      "rows": 8,
      "placeholder": "请输入内容"
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": function($event) {
        _vm.text = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitData()
      }
    }
  }, [_vm._v("保存")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d6bb20d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Model/configComponents/importConfigDialog.vue
// module id = 1832
// module chunks = 2